var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({class:[
        'gst-btn gst-btn-category-filter',
        _vm.$vuetify.breakpoint.lgAndUp && 'gst-btn-category-filter-hover' ],attrs:{"depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }